// extracted by mini-css-extract-plugin
export default {"box":"headerCom_box__7CAMu"};